<template>
  <v-container fluid>
  <v-card :loading="loading" class="ma-3">
    <v-card-title>
      <h1 class="mr-2 subheading grey--text">{{ title }}</h1>
      <v-spacer></v-spacer>
       <v-btn icon @click="accountPage"><v-icon>mdi-information</v-icon></v-btn>
       <v-chip label outlined><v-icon>mdi-warehouse</v-icon> {{ part.StockQty}} </v-chip>
      <v-btn icon @click="$router.go(-1)"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols=2 sm=2 md=2>
            <v-text-field
              v-model="part.Id"
              prepend-inner-icon="mdi-account"
              label="part"
              readonly
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols=2 sm=2 md=2>
            <v-text-field
              v-model="part.PartId"
              label="Κωδικός"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols=12 md=8 sm=8 xs=12>
            <v-textarea
              readonly
              auto-grow
              rows="1"
              :row-height="($vuetify.breakpoint.xs) ? 15 : 10"
              color="black-text"
              v-model="part.Description"
              label="Περιγραφή ανταλλακτικού"
            ></v-textarea>
          </v-col>
          <v-col cols=12 md=6 sm=8 xs=12>
            <v-text-field
              v-model="part.Category"
              label="Κατηγορία"
              readonly
            ></v-text-field>
          </v-col>
           <v-col cols=4 sm=2 md=2 xs=4>
            <v-text-field
              :value="part.StockCost.toFixed(2)"
              label="Κόστος αποθήκης"
              reverse
              readonly
              prefix="€"
            ></v-text-field>
          </v-col>
           <v-col cols=4 sm=2 md=2 xs=4>
            <v-text-field
              :value="part.SaleValue.toFixed(2)"
              label="Sale value"
              reverse
              readonly
              prefix="€"
            ></v-text-field>
          </v-col>
          <v-col cols=6 sm=4 md=2>
            <v-text-field
              v-model="part.FmSku"
              label="Κωδικός τιμολόγησης"
              readonly
            ></v-text-field>
          </v-col>
          </v-row>

      </v-container>
    </v-card-text>
    <v-card-actions>
    <v-btn
        color="primary"
        dense
        @click="showLabelDialog=true"
      >
      <v-icon>mdi-sticker</v-icon>
      </v-btn>

    <PrintDialog
      :item="part"
      :partOrder=false
      :showDialog="showLabelDialog"
      @close="handleDialogClose"
    />
      <v-tabs left>
        <slot name="tabsleft"> </slot>
      </v-tabs>

      <v-tabs right>
        <slot name="tabsright"> </slot>
      </v-tabs>
    </v-card-actions>
  </v-card>
 
  </v-container>
</template>

<script>
// import sumBy from "lodash/sumBy";
// import BalanceRow from "./BalanceRow.vue";
import PrintDialog from './PrintLabelDialog.vue'

export default {
    components: {
   //  BalanceRow,
      PrintDialog,
  },
  props: {
    title: { required: true, type: String },
    api: { required: true },
    pid: { required: true, type: Number },
  },
  watch: {
    pid() {
      this.fetchPartInfo();
    },
  },
  data() {
    return {
      loading: true,
      debits: [],
      invoices: [],
      printDialog: false,
      showLabelDialog: false,
      transactions: 0,
      part: {
        StockCost: 0,
        SaleValue: 0,
      },
     
    };
  },
  async created() {
    if (this.pid) {
      await this.fetchPartInfo();
    }
  },

  methods: {
    accountPage() {
        let path = "customer-info"
        let params = {id: this.pid}
        this.$router.push({"name": path, "params": params});
    },
    afm(afmnum) {
      return new String(Number(afmnum).toFixed()).padStart(9, "0");
    },
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value.toFixed(2));
    },
    handleDialogClose () {
      this.showLabelDialog = false;
    },
    async fetchPartInfo() {
      try {

        const response = await this.$api.get(this.api + this.pid)
        //console.log(this.$route.params.id);
        this.part = response.data;
        const cats = await this.$api.get('/inventory/parts/category/'+this.part.CategoryId)
        this.part.Category = cats.data.Description;
        this.loading = false;
       //  if (this.api == "customers/") {
       //    this.debits = this.part.Debits;
       //    this.$store.customer = this.part;
       //  } else {
       //    this.debits = this.part.Credits;
       //    this.$store.supplier = this.part;
       //  }
       //  if (this.nonBill) {
       //      this.invoices = this.part.Repairs;
       //       let cost = this.part.billing_afm != null ? sumBy(this.invoices, "RepairCost")*1.24 : sumBy(this.invoices, "RepairCost") ;
       //      this.balance = {charges: cost, debits: sumBy(this.debits, "TotalValue")};
       //  } else {
       //      this.invoices = this.part.Invoices;
       //      this.balance = {charges: sumBy(this.invoices, "TotalValue"), debits: sumBy(this.debits, "TotalValue")};
       //  }
       //  this.transactions = this.invoices.length + this.debits.length;

      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
